import React from 'react';
import axios from 'axios';
import { ReqEditGroup } from '../types/api/Groups';
import { ApiUrl } from '../conf/config';

export const useEditGroup = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const editGroup = (id: string, group: ReqEditGroup) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .put(`${ApiUrl}/admin/api/v1/groups/${id}`, group, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { editGroup, loading, error };
};
